import ArrowRoundForward from 'assets/icons/ios/ios-arrow-round-forward.svg'

ArrowRoundForward.displayName = 'ArrowRoundForward'
export default ArrowRoundForward
